import React from 'react';
import { useData } from "../../components/context/DataContext";
import { gaRegistrationButtonClick } from '../../utils/gatags';
import './Footer.css'

const Footer = () => {

    const footerData = useData();
    const insightClick = () => {
        window.open(footerData.prefs[0].link, "_blank");
        gaRegistrationButtonClick();
    }

    return (
        <>
            <footer>
                {/* <div className="insights-btn" onClick={insightClick}>To listen to the full webinar recording click here</div> */}
                <div className="footer-bg"></div>
            </footer>
        </>
    );
};

export default Footer;